export enum actionTypes {
    GAMES_PUSH = 'GAMES_PUSH',
    SET_RECENTLY_PLAYED = 'SET_RECENTLY_PLAYED',
    RESET_RECENTLY_GAMES = 'RESET_RECENTLY_GAMES'
}
